<template>
    <span>
        <input type="number" v-model="ComputedValue" />
    </span>
</template>

<script>
    export default {
        name: 'NullableIntegerInput',
        props: ["value"],
        computed: {
            ComputedValue: {
                get: function(){
                    return (this.value === null) ? "" : (this.value);
                },
                set: function (newValue) {
                    newValue = parseInt(newValue);
                    if (isNaN(newValue)) {
                        this.$emit('input', null);
                        return;
                    }
                    this.$emit('input', newValue);
                    
                }
            }
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->